import {useState, useEffect} from 'react'
import {db} from '../../../utilities'
import {auth} from '../../../Auth'
import { collection, query, where, onSnapshot } from 'firebase/firestore'

export default function useSubscribePermissions() {
  const [qualifications, setQualifications] = useState({})
  const [clients, setClients] = useState({})

  useEffect(() => {
    const subscriptions = []

    const unsubscribeQualifications = onSnapshot(
      query(collection(db, 'forms'), where('organization.id', '==', auth.sunkaizenUser.organization.id)),
      (snapshot) => {
        if (!snapshot.empty) {
          const qualifications = {}
          snapshot.forEach((form) => {
            qualifications[form.id] = {
              name: form.data().title || '',
              id: form.id,
            }
          })
          setQualifications(qualifications)
        }
      })
    subscriptions.push(unsubscribeQualifications)

    const unsubscribeClients = onSnapshot(
      query(collection(db, 'users'), where('type', '==', 'client')),
      (snapshot) => {
        if (!snapshot.empty) {
          const clients = {}
          snapshot.forEach((client) => {
            clients[client.id] = {
              name: client.data().name,
              id: client.id,
            }
          })
          setClients(clients)
        }
      })
    subscriptions.push(unsubscribeClients)

    return () => subscriptions.map((s) => s())
  }, [])

  return [qualifications, clients]
}
